
import { Card, CardContent } from "@/components/ui/card";
import { UserTable } from "@/components/admin/UserTable";
import { UserSearch } from "@/components/admin/UserSearch";
import { UserTableLoading } from "@/components/admin/UserTableLoading";
import { useUserManagement } from "@/hooks/useUserManagement";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { LoadingSpinner } from "@/components/ui/loading-spinner";

export default function AdminUsers() {
  const {
    isLoading,
    isLoadingUsers,
    searchQuery,
    setSearchQuery,
    currentUserId,
    isOwner,
    isUpdatingRole,
    isDeletingUser,
    isUpdatingVerification,
    filteredAdmins,
    filteredRegularUsers,
    handleRoleUpdate,
    handleDeleteUser,
    handleVerificationUpdate,
  } = useUserManagement();

  if (isLoading) {
    return (
      <div className="container mx-auto py-8 px-4 flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <AdminLayout title="User Management">
      <UserSearch searchQuery={searchQuery} setSearchQuery={setSearchQuery} />

      <div className="space-y-6">
        <Card>
          <CardContent className="pt-6 px-3 sm:px-6">
            {isLoadingUsers ? (
              <UserTableLoading />
            ) : (
              <UserTable
                users={filteredAdmins}
                isAdmin={true}
                currentUserId={currentUserId}
                isOwner={isOwner}
                isUpdatingRole={isUpdatingRole}
                isDeletingUser={isDeletingUser}
                isUpdatingVerification={isUpdatingVerification}
                onRoleUpdate={handleRoleUpdate}
                onDeleteUser={handleDeleteUser}
                onVerificationUpdate={handleVerificationUpdate}
                title="Administrators"
              />
            )}
          </CardContent>
        </Card>

        <Card>
          <CardContent className="pt-6 px-3 sm:px-6">
            {isLoadingUsers ? (
              <UserTableLoading />
            ) : (
              <UserTable
                users={filteredRegularUsers}
                isAdmin={false}
                currentUserId={currentUserId}
                isOwner={isOwner}
                isUpdatingRole={isUpdatingRole}
                isDeletingUser={isDeletingUser}
                isUpdatingVerification={isUpdatingVerification}
                onRoleUpdate={handleRoleUpdate}
                onDeleteUser={handleDeleteUser}
                onVerificationUpdate={handleVerificationUpdate}
                title="Users"
              />
            )}
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
}
